<template>
  <div class="create-wrap">
    <common-bg-plate>
      <change-chain></change-chain>
      <div class="create-content">
        <create-retrieval></create-retrieval>
        <!-- <detail-section title="新建链上数据">
          <el-form
            ref="formDate"
            :model="formDate"
            :rules="rules"
            label-width="70px"
            class="demo-ruleForm"
            label-position="right"
          >
            <el-form-item label="属性定义" prop="abe_policy" class="form-item-character">
              <div class="policy-wrap">
                <div class="policy-select">
                  <el-select v-model="formDate.attributes" placeholder="请选择属性集合">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      @click.native="attributesChange(item.label)"
                    >
                    </el-option>
                  </el-select>

                  <el-select
                    v-model="formDate.character"
                    class="character"
                    placeholder="请选择属性字符"
                  >
                    <el-option
                      v-for="item in characterType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      @click.native="characterChange(item.label)"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="policy-display">
                  <el-input
                    v-model="formDate.abe_policy"
                    placeholder=""
                  ></el-input>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="关键字" prop="key">
              <el-input
                v-model="formDate.key"
                placeholder="关键字只支持中文，多个关键字用,隔开"
              ></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="data">
              <el-input
                v-model="formDate.data"
                type="textarea"
                placeholder="请输入"
                :rows="10"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="submitForm('formDate')"
                >新建</el-button
              >
              <el-button
                @click="resetForm('formDate')"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </detail-section> -->
      </div>
    </common-bg-plate>
  </div>
</template>
<script>
import changeChain from '../privacyComputing/components/changeChain.vue'
import createRetrieval from '../blockchain/createRetrieval/index'
export default {
  components: {
    changeChain,
    createRetrieval
  },
  data() {
    return {
      characterType: [
        {
          label: '(',
          value: '('
        },
        {
          label: ')',
          value: ')'
        },
        {
          label: ' AND ',
          value: ' AND '
        },
        {
          label: ' OR ',
          value: ' OR '
        }
      ],
      formDate: {
        attributes: '',
        character: '',
        abe_policy: '', //策略表达式
        key: '', //关键字
        data: ''
      },
      rules: {
        abe_policy: [
          { required: true, message: '请输入策略表达式', trigger: 'blur' }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        key: [
          { required: true, message: '请输入关键字', trigger: 'blur' }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        data: [
          {
            required: true,
            message: '请输入文本',
            trigger: 'blur'
          }
        ]
      },
      options: []
    }
  },
  mounted() {},
  methods: {
    attributesChange(val) {
      this.formDate.abe_policy += val
    },
    characterChange(val) {
      this.formDate.abe_policy += val
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const userID = JSON.parse(localStorage.getItem('userID'))
          let params = {}
          params.abe_policy = this.formDate.abe_policy
          params.data = this.formDate.data
          params.key_words = this.formDate.key
          params.chain_id = this.info.ChainId
          params.user_id = userID

          // this.$apis.chain
          //   .uploadData(params)
          //   .then(res => {
          //     this.$message.success('数据上链成功')
          //     this.handleCancel()
          //   })
          //   .catch(err => {
          //     return
          //   })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('create-wrap', (), ());
.create-wrap {
  @include adaptation(
    (
      --create-wrap-content-padding: 12px 20px,
      --create-wrap-select-item-margin-left: 16px,
      --create-wrap-display-margin-top: 16px
    )
  );
  --create-wrap-min-height: var(--base-main-router-body-avaliable-height);
  .common-bg-plate {
    min-height: var(--create-wrap-min-height);
    .create-content {
      padding: var(--create-wrap-content-padding);
      .policy-wrap {
        display: flex;
        flex-direction: column;

        .policy-select {
          display: flex;

          .el-select {
            flex: 1;
          }

          :not(:first-child) {
            margin-left: var(--create-wrap-select-item-margin-left);
          }
        }

        .policy-display {
          margin-top: var(--create-wrap-display-margin-top);
        }
      }
    }
  }
}
</style>
